/* STADTHOLZ Produkt-Konfigurator — Alpine.js component.
   Free-form selection: Modell / Holzart / Stofffarbe always visible, plus Gravur.
   Purchase modes (min. one thing chosen):
     'fliege' — complete bow tie (Vater=Modell+Holz product, Stoff=variant)
     'holz'   — Wechselholz alone (standalone product per Modell+Holz combo)
     'stoff'  — Wechselstoff alone (standalone fabric product)
   Gravur: text + placement note as line-item properties, priced via a hidden
   Gravur service product (one variant), quantity = number of engraved sides.
   Clasp is always included. Availability comes from variant.available (JTL sync). */

document.addEventListener('alpine:init', function () {
  window.Alpine.data('szKonfigurator', function (config) {
    return {
      combos: config.combos || [],
      mode: 'fliege',
      // Jede Auswahl bekommt eine Nummer. Antworten mit veralteter Nummer
      // werden verworfen, sonst ueberschreibt eine langsame Antwort die neuere.
      reqSeq: {},
      pending: {},   // ein Zaehler je Ziel (product, stoffProduct, soloProduct)
      selections: { model: null, combo: null, fabricVariantId: null },
      product: null,
      soloProduct: null,
      stoffProduct: null,
      productCache: {},
      loading: false,
      addState: 'idle',
      addFehlerBestand: false,

      gravur: {
        enabled: false,
        text: '',
        note: '',
        sides: 1,
        variantId: config.gravurVariantId || null,
        priceCents: config.gravurPriceCents || 990,
      },

      demoFabrics: (function () {
        // "Name|#Hex" je Zeile aus der Sektionseinstellung — Demo-Modus vor dem Produkt-Sync.
        var raw = config.demoStoffeRaw || '';
        return raw.split('\n').map(function (line) {
          var parts = line.split('|');
          if (parts.length < 2) return null;
          return { title: parts[0].trim(), hex: parts[1].trim() };
        }).filter(Boolean);
      })(),

      // Wechselstoffe sind je Farbe ein EIGENES Produkt (kein Sammelprodukt mit
      // Varianten). "Stoffname|handle" je Zeile bildet sie ab. Die Varianten-ID
      // steht hier absichtlich nicht: sie kommt beim Klick aus dem Produkt-JSON,
      // so muss die Liste bei Produktaenderungen nicht gepflegt werden.
      stoffSolo: (function () {
        var raw = config.stoffSoloListeRaw || '';
        return raw.split('\n').map(function (line) {
          var parts = line.split('|');
          if (parts.length < 2) return null;
          var titel = parts[0].trim();
          var handle = parts[1].trim();
          if (!titel || !handle) return null;
          return { title: titel, handle: handle };
        }).filter(Boolean);
      })(),

      init: function () {
        var self = this;
        if (config.initialProduct && config.initialProduct.handle) {
          this.productCache[config.initialProduct.handle] = config.initialProduct;
        }
        if (this.combos.length > 0) {
          this.selectModel(this.combos[0].model);
        }
        // Modellkarten weiter oben auf der Seite waehlen das Modell hier vor (sz-fl-modelle)
        document.addEventListener('sz:konfigurator:modell', function (e) {
          var name = e.detail && e.detail.model ? String(e.detail.model).trim() : '';
          if (!name) return;
          var treffer = self.models.find(function (m) { return m === name; }) ||
            self.models.find(function (m) { return m.indexOf(name) === 0; });
          if (!treffer) return;
          if (self.mode === 'stoff') self.setMode('fliege');
          self.selectModel(treffer);
        });
        if (config.stoffSoloHandle) {
          this.fetchInto(config.stoffSoloHandle, 'stoffProduct');
        }
      },

      get demoMode() {
        return !this.loading && !this.product && this.demoFabrics.length > 0;
      },

      get demoSource() {
        return {
          variants: this.demoFabrics.map(function (f, i) {
            return { id: 'demo-' + i, title: f.title, available: true, demoHex: f.hex, featured_image: null };
          }),
          featured_image: null,
        };
      },

      get models() {
        var seen = [];
        this.combos.forEach(function (c) {
          if (seen.indexOf(c.model) === -1) seen.push(c.model);
        });
        return seen;
      },

      get woodsForModel() {
        var model = this.selections.model;
        return this.combos.filter(function (c) {
          return c.model === model;
        });
      },

      get modes() {
        var list = [{ key: 'fliege', label: 'Komplette Fliege' }];
        var hasSolo = this.combos.some(function (c) {
          return c.solo_handle;
        });
        if (hasSolo) list.push({ key: 'holz', label: 'Wechselholz einzeln' });
        if (config.stoffSoloHandle || this.stoffSolo.length > 0) {
          list.push({ key: 'stoff', label: 'Wechselstoff einzeln' });
        }
        return list;
      },

      // Ein Produkt je Stofffarbe, nach aussen wie ein Sammelprodukt. Die
      // Pseudo-ID 'solo:<handle>' kollidiert nicht mit echten Shopify-IDs
      // (Zahlen) und wird beim Kauf gegen die echte Variante getauscht.
      get stoffSoloSource() {
        if (!this.stoffSolo.length) return null;
        var self = this;
        return {
          title: 'Wechselstoff',
          featured_image: null,
          variants: this.stoffSolo.map(function (s) {
            var p = self.productCache[s.handle];
            var echt = p && p.variants && p.variants[0];
            return {
              id: 'solo:' + s.handle,
              title: s.title,
              price: echt ? echt.price : 490,
              // Vor dem Laden gilt der Stoff als lieferbar, sonst waere beim
              // ersten Blick die ganze Palette grau.
              available: echt ? !!echt.available : true,
              featured_image: echt ? echt.featured_image : null,
            };
          }),
        };
      },

      // Zu einer Pseudo-ID das echte Produkt und seine erste Variante finden.
      stoffSoloAufloesen: function (id) {
        if (typeof id !== 'string' || id.indexOf('solo:') !== 0) return null;
        var handle = id.slice(5);
        var p = this.productCache[handle];
        var v = p && p.variants ? p.variants[0] : null;
        if (!v) return null;
        return { produkt: p, variante: v, handle: handle };
      },

      setMode: function (m) {
        if (this.mode === m) return;
        this.mode = m;
        // Varianten-IDs gelten nur innerhalb eines Produkts. Beim Moduswechsel
        // die Auswahl ueber den Stoffnamen neu aufloesen statt die ID mitzunehmen.
        this.resolveFabricAcrossProducts();
        if (m === 'stoff') {
          this.gravur.enabled = false;
        }
        if (m === 'holz' && this.selections.combo) {
          this.loadSolo(this.selections.combo);
        }
      },

      selectModel: function (model) {
        if (this.selections.model === model) return;
        this.selections.model = model;
        var woods = this.woodsForModel;
        this.prefetchWoods(woods);
        var currentWoodLabel = this.selections.combo ? this.selections.combo.label : null;
        var match = woods.find(function (c) {
          return c.label === currentWoodLabel;
        });
        this.selectWood(match || woods[0]);
      },

      selectWood: function (combo) {
        if (!combo) return;
        this.selections.combo = combo;
        this.applyWoodPattern();
        this.loadProduct(combo.handle);
        if (this.mode === 'holz') this.loadSolo(combo);
      },

      // Holzkacheln: echtes Produktfoto je Modell+Holz. Die Fliegen-Produkte des
      // gewaehlten Modells werden still in den Cache geladen, die Kachel zeigt dann
      // das Titelbild des Produkts statt des gezeichneten Maserungsmusters.
      prefetchWoods: function (woods) {
        var self = this;
        (woods || []).forEach(function (c) {
          if (!c.handle || self.productCache[c.handle]) return;
          self.fetchProductJson(c.handle).catch(function () {});
        });
      },

      // Shopify-Bild in passender Breite laden. Die Kacheln sind rund 200 px breit, die
      // Produktbilder aber 2000 px (je ~300 KB): 20 Kacheln kosteten so 5,6 MB (Lighthouse
      // 15.10.2026). Der Bildserver rechnet per width-Parameter herunter.
      bildUrl: function (url, breite) {
        if (!url || typeof url !== 'string') return url || '';
        if (url.indexOf('cdn.shopify.com') === -1 && url.indexOf('/cdn/shop/') === -1) return url;
        if (/[?&]width=/.test(url)) return url;
        return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + breite;
      },

      holzBild: function (combo) {
        if (!combo) return null;
        var p = combo.handle ? this.productCache[combo.handle] : null;
        if (p) {
          // Variantenbild (Fliege mit Stoff) schlaegt das Titelbild: bei vielen Modellen ist
          // das Titelbild ein Tragebild mit Model, in der Kachel soll das Holz zu sehen sein.
          var vb = null;
          (p.variants || []).some(function (v) {
            if (v.featured_image && v.featured_image.src) { vb = v.featured_image.src; return true; }
            return false;
          });
          if (vb) return vb;
          if (p.featured_image) return p.featured_image;
        }
        return combo.bild_url || null;
      },

      loadSolo: function (combo) {
        if (combo.solo_handle) {
          this.fetchInto(combo.solo_handle, 'soloProduct');
        } else {
          this.soloProduct = null;
        }
      },

      // Ein Produkt-JSON je Handle: Cache, sonst laufende Anfrage wiederverwenden.
      // So loest ein Vorladen der Holzkacheln keine zweite Anfrage fuer dieselbe Fliege aus.
      fetchProductJson: function (handle) {
        var self = this;
        if (this.productCache[handle]) return Promise.resolve(this.productCache[handle]);
        if (this.pending[handle]) return this.pending[handle];
        var p = fetch('/products/' + handle + '.js')
          .then(function (res) {
            if (!res.ok) throw new Error('Produkt nicht gefunden: ' + handle);
            return res.json();
          })
          .then(function (json) {
            self.productCache[handle] = json;
            return json;
          })
          .finally(function () {
            delete self.pending[handle];
          });
        this.pending[handle] = p;
        return p;
      },

      fetchInto: function (handle, target) {
        var self = this;
        // Getrennte Zaehler: init() laedt Fliege und Wechselstoff direkt nacheinander,
        // ein gemeinsamer Zaehler hat die Fliegen-Antwort als veraltet verworfen.
        var seq = (this.reqSeq[target] || 0) + 1;
        this.reqSeq[target] = seq;
        if (this.productCache[handle]) {
          this[target] = this.productCache[handle];
          if (target === 'product') {
            this.loading = false;
            this.reselectFabric();
          }
          return;
        }
        if (target === 'product') {
          // Alten Artikel sofort fallen lassen, sonst bleibt er kaufbar.
          this.product = null;
          this.loading = true;
        }
        this.fetchProductJson(handle)
          .then(function (json) {
            if (seq !== self.reqSeq[target]) return;   // Auswahl hat sich weitergedreht
            self[target] = json;
            if (target === 'product') self.reselectFabric();
          })
          .catch(function () {
            if (seq !== self.reqSeq[target]) return;
            self[target] = null;
            if (target === 'product') self.selections.fabricVariantId = null;
          })
          .finally(function () {
            if (target === 'product' && seq === self.reqSeq[target]) self.loading = false;
          });
      },

      loadProduct: function (handle) {
        if (!handle) {
          // Noch kein Produkt verdrahtet (vor JTL-Sync) — Demo-Modus übernimmt.
          this.product = null;
          if (this.demoFabrics.length > 0 && !this.selections.fabricVariantId) {
            this.selectFabric(this.demoSource.variants[0]);
          }
          return;
        }
        this.fetchInto(handle, 'product');
      },

      reselectFabric: function () {
        if (!this.product || !this.product.variants) {
          this.selections.fabricVariantId = null;
          return;
        }
        var self = this;
        var previousTitle = null;
        Object.keys(this.productCache).some(function (h) {
          var p = self.productCache[h];
          var v = (p.variants || []).find(function (x) {
            return x.id === self.selections.fabricVariantId;
          });
          if (v) {
            previousTitle = v.title;
            return true;
          }
          return false;
        });
        var sameName = this.product.variants.find(function (v) {
          return v.available && v.title === previousTitle;
        });
        var firstAvailable = this.product.variants.find(function (v) {
          return v.available;
        });
        // Nur uebernehmen, wenn derselbe Stoffname existiert. Frueher wurde sonst
        // stillschweigend die erste verfuegbare Farbe gewaehlt - der Kunde haette
        // eine andere Farbe gekauft als angezeigt.
        var pick = sameName || (previousTitle ? null : firstAvailable);
        this.selections.fabricVariantId = pick ? pick.id : null;
      },

      // Sucht den aktuell gewaehlten Stoffnamen im Produkt des neuen Modus.
      // Findet er sich nicht, bleibt die Auswahl leer und der Kunde waehlt neu.
      resolveFabricAcrossProducts: function () {
        var id = this.selections.fabricVariantId;
        if (!id) return;
        var self = this;
        var name = null;
        // Pseudo-ID eines Stoff-Einzelprodukts: der Name steckt im Handle-Eintrag.
        if (typeof id === 'string' && id.indexOf('solo:') === 0) {
          var handle = id.slice(5);
          var eintrag = this.stoffSolo.find(function (s) { return s.handle === handle; });
          if (eintrag) name = eintrag.title;
        }
        if (!name) {
          Object.keys(this.productCache).some(function (h) {
            var v = (self.productCache[h].variants || []).find(function (x) { return x.id === id; });
            if (v) { name = v.title; return true; }
            return false;
          });
        }
        var ziel = this.mode === 'stoff'
          ? (this.stoffProduct || this.stoffSoloSource)
          : this.product;
        if (!ziel || !ziel.variants || !name) {
          this.selections.fabricVariantId = null;
          return;
        }
        var treffer = ziel.variants.find(function (v) { return v.available && v.title === name; });
        this.selections.fabricVariantId = treffer ? treffer.id : null;
        this.stoffSoloNachladen(this.selections.fabricVariantId);
      },

      selectFabric: function (variant) {
        if (!variant.available) return;
        this.selections.fabricVariantId = variant.id;
        if (variant.demoHex) this.applyFabricColor(variant.demoHex);
        this.stoffSoloNachladen(variant.id);
      },

      // Pseudo-ID gewaehlt: das echte Einzelprodukt holen, damit Preis, Bild und
      // Verfuegbarkeit stimmen und der Kaufknopf eine echte Varianten-ID bekommt.
      stoffSoloNachladen: function (id) {
        if (typeof id !== 'string' || id.indexOf('solo:') !== 0) return;
        var handle = id.slice(5);
        if (this.productCache[handle]) return;
        this.fetchProductJson(handle).catch(function () {});
      },

      applyFabricColor: function (hex) {
        var wrap = document.querySelector('#sz-stoff-wrap rect');
        if (wrap) wrap.setAttribute('fill', hex);
      },

      applyWoodPattern: function () {
        var layer = document.querySelector('#sz-holzstueck path');
        if (layer && this.selections.combo) {
          layer.setAttribute('fill', 'url(#pattern-' + this.selections.combo.pattern + ')');
        }
      },

      get currentVariant() {
        if (!this.product || !this.selections.fabricVariantId) return null;
        var id = this.selections.fabricVariantId;
        return this.product.variants.find(function (v) {
          return v.id === id;
        });
      },

      get mainItem() {
        if (this.mode === 'fliege') {
          var v = this.currentVariant;
          return v && v.available ? { id: v.id, price: v.price, title: this.product.title + ', ' + v.title } : null;
        }
        if (this.mode === 'holz') {
          var p = this.soloProduct;
          var sv = p && p.variants ? p.variants.find(function (x) { return x.available; }) : null;
          return sv ? { id: sv.id, price: sv.price, title: p.title } : null;
        }
        if (this.mode === 'stoff') {
          // Einzelprodukte je Farbe: die Pseudo-ID gegen die echte Variante tauschen.
          var solo = this.stoffSoloAufloesen(this.selections.fabricVariantId);
          if (solo) {
            return solo.variante.available
              ? { id: solo.variante.id, price: solo.variante.price, title: solo.produkt.title }
              : null;
          }
          var sp = this.stoffProduct;
          if (!sp) return null;
          var fv = sp.variants.find(function (x) { return x.id === this.selections.fabricVariantId; }, this);
          if (!fv) {
            fv = sp.variants.find(function (x) { return x.available; });
          }
          return fv && fv.available ? { id: fv.id, price: fv.price, title: sp.title + ', ' + fv.title } : null;
        }
        return null;
      },

      get fabricSource() {
        if (this.mode === 'stoff') return this.stoffProduct || this.stoffSoloSource;
        if (this.product) return this.product;
        return this.demoMode ? this.demoSource : null;
      },

      get selectedFabricName() {
        var id = this.selections.fabricVariantId;
        if (!id) return null;
        var src = this.fabricSource;
        if (!src || !src.variants) return null;
        var v = src.variants.find(function (x) { return x.id === id; });
        return v ? v.title : null;
      },

      get demoFabricTitle() {
        var id = this.selections.fabricVariantId;
        var v = this.demoSource.variants.find(function (x) { return x.id === id; });
        return v ? v.title : null;
      },

      get summaryText() {
        if (this.mainItem) return this.mainItem.title;
        if (this.demoMode && this.selections.combo) {
          var parts = [this.selections.model, this.selections.combo.label];
          if (this.demoFabricTitle) parts.push(this.demoFabricTitle);
          return parts.join(', ');
        }
        return 'Bitte wähle deine Kombination.';
      },

      get previewImage() {
        if (this.mode === 'holz') {
          var p = this.soloProduct;
          return p && p.featured_image ? p.featured_image : null;
        }
        var src = this.fabricSource;
        if (!src) return null;
        var id = this.selections.fabricVariantId;
        var v = (src.variants || []).find(function (x) {
          return x.id === id;
        });
        if (v && v.featured_image && v.featured_image.src) return v.featured_image.src;
        return src.featured_image || null;
      },

      get gravurAllowed() {
        // Im Demo-Modus (vor Produkt-Sync) ist die Gravur sichtbar und konfigurierbar,
        // gekauft wird sie erst, wenn das Gravur-Serviceprodukt verdrahtet ist.
        return this.mode !== 'stoff' && (!!this.gravur.variantId || this.demoMode);
      },

      get gravurTotalCents() {
        if (!this.gravur.enabled || !this.gravurAllowed) return 0;
        return this.gravur.priceCents * this.gravur.sides;
      },

      get totalCents() {
        var item = this.mainItem;
        return (item ? item.price : 0) + this.gravurTotalCents;
      },

      get priceFormatted() {
        if (this.demoMode && !this.mainItem) return 'Preis folgt in Kürze';
        return this.formatMoney(this.totalCents);
      },

      formatMoney: function (cents) {
        return (cents / 100).toFixed(2).replace('.', ',') + ' €';
      },

      get gravurValid() {
        if (!this.gravur.enabled) return true;
        return this.gravur.text.trim().length > 0;
      },

      get soldOut() {
        var src = this.mode === 'holz' ? this.soloProduct : this.fabricSource;
        if (!src || !src.variants) return false;
        return !src.variants.some(function (v) {
          return v.available;
        });
      },

      get canCheckout() {
        // Waehrend des Ladens ist nicht sicher, welcher Artikel gemeint ist.
        return !this.loading && !!this.mainItem && this.gravurValid && this.totalCents > 0;
      },

      incrementSides: function () {
        if (this.gravur.sides < 4) this.gravur.sides += 1;
      },

      decrementSides: function () {
        if (this.gravur.sides > 1) this.gravur.sides -= 1;
      },

      addToCart: function () {
        if (!this.canCheckout || this.addState === 'loading') return;
        var self = this;
        this.addState = 'loading';

        var main = this.mainItem;
        var mainProps = {};
        var items = [];
        // Eindeutige Klammer um Ware und Gravur. Der Produkttitel reicht nicht:
        // zwei gleiche Fliegen mit unterschiedlicher Gravur waeren sonst nicht
        // auseinanderzuhalten. Properties mit Unterstrich blendet Shopify aus.
        var gruppe = 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

        if (this.gravur.enabled && this.gravurAllowed) {
          mainProps['_Gravurgruppe'] = gruppe;
          mainProps['Gravur'] = 'Ja (' + this.gravur.sides + ' Seite' + (this.gravur.sides > 1 ? 'n' : '') + ')';
          mainProps['Gravurtext'] = this.gravur.text.trim();
          if (this.gravur.note.trim()) {
            mainProps['Gravur-Platzierung'] = this.gravur.note.trim();
          }
        }

        items.push({ id: main.id, quantity: 1, properties: mainProps });

        if (this.gravur.enabled && this.gravurAllowed) {
          items.push({
            id: this.gravur.variantId,
            quantity: this.gravur.sides,
            properties: {
              '_Gravurgruppe': gruppe,
              'Gravurtext': this.gravur.text.trim(),
              'Platzierung': this.gravur.note.trim() || 'keine Angabe',
              'Gehört zu': main.title,
            },
          });
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            // 422 heisst bei Shopify: Bestand reicht nicht (z. B. letzte Fliege schon im Warenkorb).
            // Dann hilft "erneut versuchen" nicht, deshalb eigene Meldung.
            self.addFehlerBestand = res.status === 422;
            if (!res.ok) throw new Error('add failed');
            self.addState = 'success';
            document.dispatchEvent(new CustomEvent('sz:cart:added'));
            setTimeout(function () {
              self.addState = 'idle';
            }, 2000);
          })
          .catch(function () {
            self.addState = 'error';
            setTimeout(function () {
              self.addState = 'idle';
            }, 3000);
          });
      },
    };
  });
});
